import type { TrackingPropsInterface } from '../../utils/enums/enums';
import type { MTextBlockSimpleProps } from '../../molecules/MTextBlockSimple/MTextBlockSimple.types';
import type { MButtonProps } from '../../molecules/MButton/MButton.types';
import type { MMediaSelectorProps } from '../../molecules/MMediaSelector/MMediaSelector.types';

export enum OBannerSplitImageScale {
  S = 'S',
  M = 'M',
  L = 'L',
}

export enum OBannerSplitInset {
  None = 'None',
  S = 'S',
  M = 'M',
  L = 'L',
}

export enum OBannerSplitLayout {
  Default = 'Default',
  Reverse = 'Reverse',
}

export enum OBannerSplitContentAlignment {
  Left = 'Left',
  Centered = 'Centered',
}

export type OBannerSplitProps = {
  imageScale?: OBannerSplitImageScale;
  inset?: OBannerSplitInset;
  layout?: OBannerSplitLayout;
  contentAlignment?: OBannerSplitContentAlignment;
  mTextBlockSimple?: MTextBlockSimpleProps;
  mButton?: MButtonProps;
  mMediaSelector?: MMediaSelectorProps;
  mediaColorSet?: string;
  trackingProperties?: TrackingPropsInterface;
  className?: string;
};
